<template>
  <div class="card-wrapper" :class="cardWrapperClasses">
    <div class="card"
         @click="select"
         @keydown.prevent.space="select">
      <div class="back">
        <!-- The card front is on the visual back -->
        <CardFront :card="card"></CardFront>
      </div>
      <div class="front">
        <!-- The card back is on the visual front -->
        <CardBack :card="card"></CardBack>
      </div>
    </div>
  </div>
</template>

<script>
  import CardBack from '@/components/card/CardBack.vue';
  import CardFront from '@/components/card/CardFront.vue';
  import Card from '@/models/Card';


  export default {
    name: 'Card',
    components: {
      CardBack,
      CardFront,
    },
    props: {
      card: {
        type: Card,
        required: true,
      },
      selected: {
        type: Boolean,
        required: true,
      },
      found: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      cardWrapperClasses() {
        const cardClasses = [];

        if (this.selected || this.isFound) {
          cardClasses.push('card-wrapper--revealed');
        }

        if (this.selected) {
          cardClasses.push('card-wrapper--selected');
        }

        if (this.found) {
          cardClasses.push('card-wrapper--found');
        }

        return cardClasses.join(' ');
      },
    },
    methods: {
      select() {
        this.$emit('select', this.card.id);
      },
    },
  };
</script>

<style scoped lang="scss">
  //
  // Notes: https://davidwalsh.name/css-flip
  //
  @import "../../config/styles/settings";
  @import "../../config/styles/util";

  .card-wrapper {
    perspective: 1000px;
  }

  .card {
    @include shadow-flat($purple-500, 0.64);
    border-radius: 3px;
  }

  .card-wrapper.card-wrapper--found .card,
  .card-wrapper.card-wrapper--selected .card,
  .card-wrapper.card-wrapper--revealed .card {
    transform: rotateY(180deg);
  }

  .card, .front, .back {
    width: 100%;
    height: 150px;
  }

  .card {
    transition: 0.6s;
    transform-style: preserve-3d;
    position: relative;
  }

  .front, .back {
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }

  .front {
    z-index: 2;
    transform: rotateY(0deg);
  }

  .back {
    transform: rotateY(180deg);
  }
</style>
